import mixpanel from 'mixpanel-browser'
import {
  MP_CREATE_GAME_SETTING,
  MP_UPDATE_GAME_SETTING,
  MP_DELETE_GAME_SETTING,
} from '../constants/mixpanel_events'

const baseUrl = (gameId) => `/games/${gameId}/game_settings`

export const GAME_SETTING_PIXELS = 'pixels'

export const save = async (values, gameId, token) => {
  const response = await fetch(baseUrl(gameId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': token
    },
    body: JSON.stringify(values)
  })
  const data = await response.json()
  mixpanel.track(MP_CREATE_GAME_SETTING, { gameId })
  return data
}

export const update = async (values, gameSettingId, gameId, token) => {
  const response = await fetch(`${baseUrl(gameId)}/${gameSettingId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': token
    },
    body: JSON.stringify(values)
  })
  const data = await response.json()
  mixpanel.track(MP_UPDATE_GAME_SETTING, { gameId })
  return data
}

export const destroy = async (gameSettingId, gameId, token) => {
  const response = await fetch(`${baseUrl(gameId)}/${gameSettingId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': token
    }
  })
  const data = await response.json()
  mixpanel.track(MP_DELETE_GAME_SETTING, { gameId })
  return data
}